class Cursor {
	constructor() {
		this.cursor = document.querySelector('#circularcursor');
		this.slide = document.querySelectorAll('.swiper-slide');
		this.header = document.querySelector('.header-main');
		this.cursorMove();
	}

	cursorMove() {
		this.slide.forEach((slide) => {
			slide.addEventListener('mousemove', (e) => {
				this.cursor.style = `top: ${e.clientY}px; left: ${e.clientX}px;`;
			});

			slide.addEventListener('mouseenter', () => {
				this.header.style = `pointer-events: none;`;
			});

			slide.addEventListener('mouseleave', () => {
				this.cursor.style.opacity = 0;
				this.cursor.style.transform = 'scale(0)';
			});
		});
	}
}
